// Where the full-size document viewer (/FullDocImage) may load images from.
// Keyed by REACT_APP_ENV, like the Okta config in ConfigUrl.js, so each build
// only trusts its own environment's upload bucket (hosts as in be-customer's
// manifests/<env>-deploy.yml S3_ENDPOINT).
const S3_IMAGE_HOSTS = {
  production: ["th-b2c-s3-file-upload-bucket-prod-ap-southeast-1.s3.ap-southeast-1.amazonaws.com"],
  uat: ["th-b2c-staging-s3-file-upload-bucket-uat-ap-southeast-1.s3.ap-southeast-1.amazonaws.com"],
  dev_uat: ["th-b2c-staging-s3-file-upload-bucket-uat-ap-southeast-1.s3.ap-southeast-1.amazonaws.com"],
  sit: ["th-b2c-dev-s3-file-upload-bucket-test-ap-southeast-1.s3.ap-southeast-1.amazonaws.com"],
  dev_sit: ["th-b2c-dev-s3-file-upload-bucket-test-ap-southeast-1.s3.ap-southeast-1.amazonaws.com"],
};

const IMAGE_PATH = /\.(png|jpe?g)$/i;
// A presigned S3 URL (AWS SDK v3 getSignedUrl) carries X-Amz-* parameters plus
// x-id=GetObject; any other parameter, or an empty one ("?&"), is refused.
const presignedParam = ([key, value]) =>
  /^X-Amz-/i.test(key) || (/^x-id$/i.test(key) && value === "GetObject");

export const s3ImageHosts = (env = process.env.REACT_APP_ENV) =>
  S3_IMAGE_HOSTS[(env || "").trim()] || [];

/**
 * The URL to render, or null. Security (OWASP A01/A10, CodeQL
 * js/client-side-unvalidated-url-redirection): callers render only this value,
 * never the raw query parameter.
 */
export function safeImageUrl(url, allowedHosts = s3ImageHosts()) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch (e) {
    return null;
  }
  const ok =
    parsed.protocol === "https:" &&
    !parsed.username &&
    !parsed.password &&
    !parsed.hash &&
    allowedHosts.includes(parsed.host) &&
    IMAGE_PATH.test(parsed.pathname) &&
    (!parsed.search || parsed.searchParams.toString() !== "") &&
    [...parsed.searchParams].every(presignedParam) &&
    [...parsed.searchParams.keys()].filter((key) => /^x-id$/i.test(key)).length <= 1;
  return ok ? parsed.href : null;
}
